import logo from 'assets/images/ALCS_Primary_Digital_RGB.png'
import { Link } from 'react-router-dom'

// ReSharper disable once InconsistentNaming
const SiteLogo = (props) => {
    return (
        <div id='brand-container' className='col-auto d-flex justify-content-center'>
            <Link to="/">
                <img src={logo} className='chassis-brand header-logo' id={props.id + '-brand-logo'} alt='logo' />
            </Link>
        </div>
    )
}

export default SiteLogo
